import { Grid } from '@elliemae/ds-grid';
import type { Theme } from '@elliemae/ds-system';
import { styled } from '@elliemae/ds-system';
import { DSLeftNavigationName, LEFT_NAVIGATION_SLOTS } from '../../constants/index.js';

type LeftNavProps = {
  expanded: boolean;
  expandedWidth: string;
};

const getLeftShadowStyles = ({
  selected,
  selectedParent,
  theme,
}: {
  selected: boolean;
  selectedParent?: boolean;
  theme: Theme;
}) => {
  if (!selected && !selectedParent) {
    return `
      box-shadow: inset 4px 0 0 0 transparent;
      :hover {
        box-shadow: inset 4px 0 0 0 ${theme.colors.brand[300]};
      }
      :active {
        box-shadow: inset 4px 0 0 0 ${theme.colors.brand[400]};
      }
    `;
  }
  return `box-shadow: inset 4px 0 0 0 ${theme.colors.brand[400]};`;
};

export const StyledLeftNavExpandAnimationWrapper = styled('nav', {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.ROOT,
})<LeftNavProps>`
  width: ${(props) => (props.expanded ? props.expandedWidth : '48px')};
  transition: width ${(props) => (props.expanded ? 'ease-out' : 'ease-in')} 350ms;
  box-shadow: -1px 0 0 0 ${(props) => props.theme.colors.neutral[100]};
  border: 1px solid ${(props) => props.theme.colors.neutral[100]};
  overflow: hidden;
  height: 100%;
  position: relative;
`;

export const StyledLeftNavAreasContainer = styled(Grid, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.AREAS_CONTAINER,
})<LeftNavProps>`
  width: ${(props) => (props.expanded ? `calc(${props.expandedWidth} - 2px)` : '46px')};
  height: 100%;
`;

export const StyledLeftNavHeaderArea = styled('div', {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.HEADER_AREA,
})<{ selected: boolean; selectedParent?: boolean }>`
  ${getLeftShadowStyles}
`;

export const StyledLeftNavBodyAreasContainer = styled(Grid, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.BODY_AREAS_CONTAINER,
})`
  width: 100%;
`;

export const StyledLeftNavBodyHeaderArea = styled('div', {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.BODY_HEADER_AREA,
})<{ selected: boolean; selectedParent?: boolean; isSkeleton: boolean }>`
  width: 100%;
  ${({ isSkeleton }) => (!isSkeleton ? getLeftShadowStyles : '')}
`;

export const StyledLeftNavBodyItemsArea = styled('div', {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.BODY_ITEMS_AREA,
})<{ selected: boolean; isSkeleton: boolean }>`
  width: 100%;
  overflow: auto;
  box-shadow: ${({ isSkeleton, selected, theme }) =>
    !isSkeleton ? `inset 4px 0 0 0 ${selected ? theme.colors.brand[400] : 'transparent'}` : ''};
`;
